import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "trigger"]

  connect() {
    this.showTimeout = null
    this.hideTimeout = null
    console.log('PlaceOwner hovercard connected', this.element)
  }

  disconnect() {
    this.clearTimeouts()
  }

  mouseEnter() {
    console.log('Mouse entered trigger')
    this.clearTimeouts()
    this.showTimeout = setTimeout(() => {
      this.showCard()
    }, 200) // Small delay before showing
  }

  mouseLeave() {
    this.clearTimeouts()
    this.hideTimeout = setTimeout(() => {
      this.hideCard()
    }, 200) // Small delay to allow moving to the card
  }

  cardMouseEnter() {
    // Cancel hide when mouse enters the card
    this.clearTimeouts()
  }

  cardMouseLeave() {
    // Hide immediately when mouse leaves the card
    this.hideCard()
  }

  showCard() {
    console.log('Showing card', this.cardTarget)
    this.cardTarget.classList.remove("hidden")
    this.positionCard()
  }

  hideCard() {
    this.cardTarget.classList.add("hidden")
  }

  clearTimeouts() {
    if (this.showTimeout) {
      clearTimeout(this.showTimeout)
      this.showTimeout = null
    }
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
  }

  positionCard() {
    const triggerRect = this.triggerTarget.getBoundingClientRect()
    const card = this.cardTarget
    const cardHeight = card.offsetHeight
    const cardWidth = card.offsetWidth

    // Calculate space above and below trigger
    const spaceAbove = triggerRect.top
    const spaceBelow = window.innerHeight - triggerRect.bottom

    // Position vertically - prefer above, but use below if not enough space
    let top
    if (spaceAbove >= cardHeight + 10 || spaceAbove > spaceBelow) {
      // Position above
      top = triggerRect.top - cardHeight - 10
    } else {
      // Position below
      top = triggerRect.bottom + 10
    }

    // Position horizontally - ensure it stays within viewport
    let left = triggerRect.left
    const spaceRight = window.innerWidth - triggerRect.left

    if (spaceRight < cardWidth) {
      // Align to right edge of viewport with some padding
      left = window.innerWidth - cardWidth - 20
    }

    card.style.top = `${Math.max(10, top)}px`
    card.style.left = `${Math.max(10, left)}px`
  }
}
